import { render, staticRenderFns } from "./SupplyMetrics.vue?vue&type=template&id=55ea0118&scoped=true&"
import script from "./SupplyMetrics.vue?vue&type=script&lang=js&"
export * from "./SupplyMetrics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ea0118",
  null
  
)

export default component.exports